import { EventEmitter } from "events";
export default class Loader extends EventEmitter {
  constructor() {
    super();
    this.dict = {};
    this.index = 0;
  }
  load(list) {
    console.log("list", list);
    this.index = 0;
    list.forEach(item => {
      let img = new Image();
      img.onload = i => {
        // console.log("[Loader] img load", img.src, i);
        img.onload = null;
        this.dict[item] = img;
        this.index++;
        // console.log("this.index", this.index, list.length);
        if (list.length == this.index) {
          this.complete();
        }
      };
      // console.log("[Loader] item", item);
      img.src = item;
    });
  }
  complete() {
    this.emit("complete");
  }
  getImg(imgName){
    const result = this.dict[imgName];
    return result;
  }
}
